import { GetCustomerBillsResponse } from '@aaa-ncnu-ie/mypolicy-api-customers';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import axios from './axios';

export const getBills = async (): Promise<GetCustomerBillsResponse> => {
  const { data } = await axios.get<GetCustomerBillsResponse>(
    `${import.meta.env.VITE_CUSTOMERS_API_URL}/v1/customers/bills`,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    }
  );

  return data;
};

export const useBillsQuery = (enabled?: boolean) =>
  useQuery({
    queryKey: ['bills'],
    queryFn: () => getBills(),
    staleTime: 1000 * 60 * 3,
    enabled,
  });
